import { TYPE_NUMBER } from './input-types';

export const id = 'shippingPaid';
export const apiKey = 'ShippingPaid';
export const type = TYPE_NUMBER;

export const shippingPaid = {
  id,
  apiKey,
  type,
};
